import { useState, useCallback } from 'react';

interface Route {
  view: string;
  params?: any;
}

interface UseNavigationReturn {
  // State
  history: Route[];
  currentRoute: Route;

  // Handlers
  navigate: (view: string, params?: any) => void;
  goBack: () => void;
  setHistory: (history: Route[] | ((prev: Route[]) => Route[])) => void;
}

export const useNavigation = (): UseNavigationReturn => {
  const [history, setHistory] = useState<Route[]>(() => {
    // Initialize based on URL path
    const path = window.location.pathname;
    if (path === '/devadmin' || path === '/devadmin/') {
      return [{ view: 'devadmin' }];
    }
    return [{ view: 'schedule' }];
  });

  const currentRoute = history[history.length - 1];

  // Navigation helpers
  const navigate = useCallback((view: string, params?: any) => {
    setHistory(prev => [...prev, { view, params }]);
  }, []);

  const goBack = useCallback(() => {
    setHistory(prev => {
      if (prev.length > 1) {
        return prev.slice(0, prev.length - 1);
      }
      return prev;
    });
  }, []);

  return {
    history,
    currentRoute,
    navigate,
    goBack,
    setHistory,
  };
};
